module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }